import React from 'react';
import { Navbar, Nav, Container, Row, Col, Footer } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../tps.css"
const Header = () => {
    return (
        <div className="App">
            <div className="nav-container">
             <Navbar > {/*bg="primary" variant="dark" expand="lg" */}
                <Container>
                    <Navbar.Brand href="/" className='ml-2 text-white headline'>Technical Paper Submission</Navbar.Brand>
                    {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
                    {/* <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="/">Home</Nav.Link>
                            <Nav.Link href="#about">About</Nav.Link>
                            <Nav.Link href="#contact">Contact</Nav.Link>
                            <Nav.Link href="#login">Login</Nav.Link>
                            <Nav.Link href="#register">Register</Nav.Link>
                        </Nav>
                    </Navbar.Collapse> */}
                </Container>
            </Navbar>
            </div>

        </div>
    );
};



export default Header;